// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","info":"Footer_info__2OKti","socials":"Footer_socials__bqeqA","copyright":"Footer_copyright__QJwUC"};